export default "<div class=\"responsive\">\r\n  <cometchat-user-list\r\n    (onUserClick)=\"userClicked($event)\"\r\n  ></cometchat-user-list>\r\n</div>\r\n";